import { apiClient } from './client';
import { EnvVarResponse } from '../types';

export const getEnvVars = () =>
  apiClient.get<EnvVarResponse[]>('/api/env').then(r => r.data);

export const createEnvVar = (key: string, value: string) =>
  apiClient.post<EnvVarResponse>('/api/env', { key, value }).then(r => r.data);

export const deleteEnvVar = (id: string) =>
  apiClient.delete(`/api/env/${id}`).then(() => {});
